﻿import { Checkbox, Form } from "antd";
import { bool, func, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
import { disableToggle } from "./helper";

const NEEDED_FOR_ALIGNMENT = " ";

const NotApplicableToggle = ({ roleId, value, status, handleToggle }) => {
  const intl = useIntl();

  const [disabled] = useState(() => disableToggle(status));

  return (
    <Form.Item
      name={[roleId, "isNotApplicable"]}
      valuePropName="checked"
      initialValue={value ?? true}
      label={NEEDED_FOR_ALIGNMENT}
    >
      <Checkbox
        onChange={({ target: { checked } }) => handleToggle(checked)}
        data-test-id={`milestone-set-na-toggle-${roleId}`}
        disabled={disabled}
      >
        {intl.formatMessage({
          id: "project.notApplicable",
        })}
      </Checkbox>
    </Form.Item>
  );
};

NotApplicableToggle.propTypes = {
  roleId: string.isRequired,
  value: bool,
  status: string,
  handleToggle: func.isRequired,
};

export default NotApplicableToggle;
